import { connect } from 'react-redux'
import { isOffline } from 'redux-offline-status'

import OfflineStatus from './OfflineStatus'

const mapStateToProps = state => {
  return {
    isOffline: isOffline(state),
  }
}

export default connect(mapStateToProps, null)(OfflineStatus)
